<div class="wrapper p-2">
    <div class="container-flex d-flex justify-content-center">
        <div class="content-area card">
            <!--<div class="content-body">-->
                <iframe [src]="safeUrl"></iframe>
            <!--</div>-->
        </div>
    </div>
</div>
